import { Project } from '@/api/rest/resources/conservation';

import { useConservationProjectName } from './useConservationProjectName';

const IMG_EXTENSIONS = ['jpg', 'png'] as const;

const getImage = ({ projectKey, name }: { projectKey: Project['id']; name: string }) => {
  const hasNameExtension = IMG_EXTENSIONS.some((ext) => name.endsWith(`.${ext}`));

  const imagePath = hasNameExtension ? name : `${name}.png`;

  return new URL(`../../projects/${projectKey}/${imagePath}`, import.meta.url).href;
};

export const useStaticImage = (name: string) => {
  const projectName = useConservationProjectName();

  if (!projectName) {
    throw new Error('Conservation project name not found');
  }

  return getImage({ projectKey: projectName, name });
};
